import setDeviceInfo from './set-device-info'
import setWindowDimensions from './set-window-dimensions'

export default function(ctx) {
  setWindowDimensions(ctx)
  setDeviceInfo(ctx)
}
